<template>
    <div draggable="true" :id="id" v-on="$listeners" v-bind="$attrs">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        id: [String, Number]
    }
}
</script>